import Style from './PopupPage.module.less';
import StepBrick from '../StepBrick/StepBrick';
import InlineSVG from 'react-inlinesvg';
import closeIcon from '../../assets/icon/close.svg';
import { useDispatch } from 'react-redux';
import FJAction from '../../action/FJAction';
import { useEffect } from 'react';
import FJUtil from '../../util/FJUtil';

const SinglePage = props => {
    const dispatch = useDispatch();
    let { page } = props;
    let _close = () => {
        dispatch(FJAction.closeLoginView());
    };
    useEffect(() => {
        FJUtil.ealog('sign up visit', {
            'page&panel': 'panel',
            page: page,
        });
    }, []);
    return (
        <div className={Style.popupPage}>
            <div className={Style.popupPage_content}>
                <StepBrick popupType hasLogo style={{ width: '340px' }} />
                <div className={Style.close_box} onClick={_close}>
                    <InlineSVG src={closeIcon} />
                </div>
            </div>
        </div>
    );
};
export default SinglePage;
